<template>
  <div
    class="px-2 border-b-sm d-flex align-center"
    :class="
      isRailModelValue
        ? 'justify-center py-5 pb-6'
        : 'justify-space-between py-5'
    "
  >
    <BaseLogo v-if="!isRailModelValue" />

    <button @click="toggleOpen">
      <VIcon :icon="isRailModelValue ? 'sidebarOpen' : 'sidebarClose'" />
    </button>
  </div>
</template>

<script lang="ts" setup>
import { VIcon } from 'vuetify/components'
import type { Emits, Props } from './TheSideBarHeader.types'
import BaseLogo from '@/modules/Core/components/base/BaseLogo/BaseLogo.vue'

defineProps<Props>()
defineEmits<Emits>()

const isRailModelValue = defineModel<boolean>('rail')

function toggleOpen() {
  isRailModelValue.value = !isRailModelValue.value
}
</script>
